var map = {
	"./bug.svg": 370,
	"./dark.svg": 357,
	"./dragon.svg": 771,
	"./electric.svg": 846,
	"./fairy.svg": 218,
	"./fighting.svg": 792,
	"./fire.svg": 376,
	"./flying.svg": 339,
	"./ghost.svg": 781,
	"./grass.svg": 899,
	"./ground.svg": 280,
	"./ice.svg": 587,
	"./normal.svg": 295,
	"./poison.svg": 470,
	"./psychic.svg": 879,
	"./rock.svg": 155,
	"./steel.svg": 226,
	"./water.svg": 529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97;